/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ArrayPublishedAndDraftResourceScheduler,
  CallerRef,
  MapString,
  PublishedAndDraftResourceScheduler,
  ResourceScheduler,
  ResourceSchedulerDraft,
  ResourceSchedulerDraftCreateRequest,
  ResourceSchedulerDraftUpdateRequest,
} from "./data-contracts";
import { ContentType, FullRequestParams, HttpClient, QueryParamsType, RequestParams } from "../http-client";

export class V1<SecurityDataType = unknown> {
  // See templates/api.ejs we need this in order to send as parameter to request call
  serviceName = "resource-scheduler";
  /**
   * @deprecated Internal use only.
   */
  httpClient: HttpClient<SecurityDataType>;

  constructor(config?: ConstructorParameters<typeof HttpClient<SecurityDataType>>[0]) {
    this.httpClient = new HttpClient(config);
  }

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  request = <T = any, E = any>(params: FullRequestParams): Promise<T> => {
    return this.httpClient.clientRequest<T, E>({ ...params, serviceName: this.serviceName });
  };

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  getServicePath = <Q extends QueryParamsType>(path: string, query?: Q): string => {
    const servicePath = this.httpClient.clientGetPath({ path, serviceName: this.serviceName });

    if (!query) return servicePath;

    const queryParams = this.httpClient.encodeQueryParams(query);
    return `${servicePath}?${queryParams}`;
  };

  /**
   * @description Create Resource Scheduler
   *
   * @tags External/CRUD/ResourceScheduler
   * @name CreateResourceScheduler
   * @request PUT:/v1/tenant/{tenantId}/resource-scheduler/draft
   * @secure
   */
  createResourceScheduler = (tenantId: string, data: ResourceSchedulerDraftCreateRequest, params: RequestParams = {}) =>
    this.request<
      ResourceSchedulerDraft,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/resource-scheduler/draft`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for createResourceScheduler */
  createResourceSchedulerPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/resource-scheduler/draft`);

  /**
   * @description Update Resource Scheduler
   *
   * @tags External/CRUD/ResourceScheduler
   * @name UpdateResourceScheduler
   * @request PUT:/v1/tenant/{tenantId}/resource-scheduler/{resourceSchedulerId}/draft
   * @secure
   */
  updateResourceScheduler = (
    tenantId: string,
    resourceSchedulerId: string,
    data: ResourceSchedulerDraftUpdateRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      ResourceSchedulerDraft,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/resource-scheduler/${resourceSchedulerId}/draft`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for updateResourceScheduler */
  updateResourceSchedulerPathGetter = (tenantId: string, resourceSchedulerId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/resource-scheduler/${resourceSchedulerId}/draft`);

  /**
   * @description Delete Resource Scheduler
   *
   * @tags External/CRUD/ResourceScheduler
   * @name DeleteResourceScheduler
   * @request DELETE:/v1/tenant/{tenantId}/resource-scheduler/{resourceSchedulerId}/draft
   * @secure
   */
  deleteResourceScheduler = (tenantId: string, resourceSchedulerId: string, params: RequestParams = {}) =>
    this.request<
      ResourceSchedulerDraft,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/resource-scheduler/${resourceSchedulerId}/draft`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteResourceScheduler */
  deleteResourceSchedulerPathGetter = (tenantId: string, resourceSchedulerId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/resource-scheduler/${resourceSchedulerId}/draft`);

  /**
   * @description Update Resource Scheduler
   *
   * @tags External/CRUD/ResourceScheduler
   * @name UpdateResourceScheduler2
   * @request PUT:/v1/tenant/{tenantId}/resource-scheduler/{resourceSchedulerId}
   * @originalName updateResourceScheduler
   * @duplicate
   * @secure
   */
  updateResourceScheduler2 = (tenantId: string, resourceSchedulerId: string, params: RequestParams = {}) =>
    this.request<
      ResourceScheduler,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/resource-scheduler/${resourceSchedulerId}`,
      method: "PUT",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for updateResourceScheduler2 */
  updateResourceScheduler2PathGetter = (tenantId: string, resourceSchedulerId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/resource-scheduler/${resourceSchedulerId}`);

  /**
   * @description Delete Resource Scheduler
   *
   * @tags External/CRUD/ResourceScheduler
   * @name DeleteResourceScheduler2
   * @request DELETE:/v1/tenant/{tenantId}/resource-scheduler/{resourceSchedulerId}
   * @originalName deleteResourceScheduler
   * @duplicate
   * @secure
   */
  deleteResourceScheduler2 = (tenantId: string, resourceSchedulerId: string, params: RequestParams = {}) =>
    this.request<
      ResourceScheduler,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/resource-scheduler/${resourceSchedulerId}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteResourceScheduler2 */
  deleteResourceScheduler2PathGetter = (tenantId: string, resourceSchedulerId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/resource-scheduler/${resourceSchedulerId}`);

  /**
   * @description Get Resource Scheduler with draft
   *
   * @tags External/CRUD/ResourceScheduler
   * @name GetResourceSchedulerWithDraft
   * @request GET:/v1/tenant/{tenantId}/resource-scheduler/{resourceSchedulerId}/with-draft
   * @secure
   */
  getResourceSchedulerWithDraft = (tenantId: string, resourceSchedulerId: string, params: RequestParams = {}) =>
    this.request<
      PublishedAndDraftResourceScheduler,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/resource-scheduler/${resourceSchedulerId}/with-draft`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getResourceSchedulerWithDraft */
  getResourceSchedulerWithDraftPathGetter = (tenantId: string, resourceSchedulerId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/resource-scheduler/${resourceSchedulerId}/with-draft`);

  /**
   * @description Get by workspace Resource Scheduler
   *
   * @tags External/CRUD/ResourceScheduler
   * @name GetBulkResourceScheduler
   * @request GET:/v1/tenant/{tenantId}/resource-scheduler
   * @secure
   */
  getBulkResourceScheduler = (
    tenantId: string,
    query: {
      /**
       * @pattern [^\s\\/]+
       * @example "someWorkspaceId"
       */
      workspaceId: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      ArrayPublishedAndDraftResourceScheduler,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/resource-scheduler`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getBulkResourceScheduler */
  getBulkResourceSchedulerPathGetter = (
    tenantId: string,
    query: {
      /**
       * @pattern [^\s\\/]+
       * @example "someWorkspaceId"
       */
      workspaceId: string;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/resource-scheduler`, query);
}
